import { Component, HostBinding, OnInit } from '@angular/core';
import * as fromApp from '../../../store/app.reducers';
import { Store } from '@ngrx/store';
import { pageAnimation } from '@app/core/animations/element.animations';
import { DomSanitizer } from '@angular/platform-browser';
import { map } from 'rxjs/operators';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    animations: [pageAnimation]
})
export class LoginComponent implements OnInit {

    @HostBinding('@pageAnimation') animate = true;
    loginError$ = this.store.select(fromApp.getLoginError).pipe(map(raw => !!raw && this.sanitizer.bypassSecurityTrustHtml(raw)));

    constructor(
        private store: Store<fromApp.AppState>,
        private sanitizer: DomSanitizer) {
    }


    ngOnInit() {
    }
}
